import React, { Component } from 'react';
import Radio from '../CommonComponents/Radio';
import Input from '../CommonComponents/Input';
import Button from '../CommonComponents/Button';

type Props = {
  comment: string;
  onCancel: Function;
  onConfirm: Function;
  onCommentChange: Function;
  onEndReasonSelect: Function;
  source?: string;
  sessionID?: string;
};
type State = {
  reasonIndex: number;
};

export default class EndChat extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
  }

  setInitialState(): State {
    return {
      reasonIndex: 0,
    };
  }

  setEndReason(index: number) {
    this.setState({
      reasonIndex: index,
    });
  }
  componentDidUpdate(prevProps: Props, _: State) {
    if (this.props.sessionID !== prevProps.sessionID) {
      this.setState({
        reasonIndex: 0,
      });
    }
  }
  render() {
    let options = ['resolved', 'unresolved', 'abandoned'];
    return (
      <div id='end-chat-wrapper'>
        <div
          style={
            this.props.source === 'collectStatus'
              ? { display: 'flex', justifyContent: 'space-between' }
              : {}
          }>
          {options.map((option, index) => {
            return (
              <Radio
                label={option[0].toUpperCase() + option.slice(1)}
                id={option}
                checked={this.state.reasonIndex === index}
                onSelect={() => {
                  this.props.onEndReasonSelect(option);
                  this.setEndReason(index);
                }}
              />
            );
          })}
        </div>
        <Input
          label='Add comment'
          value={this.props.comment}
          onValueChange={this.props.onCommentChange}
        />
        <Button
          text='Done'
          theme='dark'
          // disabled={!new RegExp('^\\s*\\w+[\\w,;\'"\\s.?!]*$').test(this.props.comment)}
          onClick={() => {
            // if (this.props.comment) {
            this.props.onConfirm(
              this.props.source !== 'collectStatus' ? 'agent' : 'user',
              this.props.source !== 'collectStatus' ? 'Chat ended' : 'Chat status updated'
            );
            // }
          }}
          collectStatus='true'
          endStatus='true'
        />
        {this.props.source !== 'collectStatus' && (
          <Button
            text='Cancel'
            theme='light'
            onClick={() => {
              this.props.onCancel();
            }}
            endStatus='cancel'
          />
        )}
      </div>
    );
  }
}
